{
  "webhooks": {
    "navigation_title": "Webhooks",
    "title": "Webhooks",
    "create": "Crear Webhook",
    "docs": "Documentación",
    "delete_webhook": "Eliminar Webhook",
    "conditions": "Condiciones",
    "types": {
      "device": "Dispositivo",
      "alert": "Alerta"
    },
    "dialogs": {
      "delete": {
        "title": "¿Está seguro?",
        "content": "¿Está seguro de que desea eliminar este webhook? No puede deshacer esta acción",
        "confirm": "Eliminar"
      }
    }
  }
}
